import { render, staticRenderFns } from "./DataCheck.vue?vue&type=template&id=09ac2c05&"
import script from "./DataCheck.vue?vue&type=script&lang=js&"
export * from "./DataCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports